<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        class="fill-current"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.7471 14.9921C22.7471 19.2619 19.2857 22.7233 15.0159 22.7233C10.7461 22.7233 7.28467 19.2619 7.28467 14.9921C7.28467 10.7223 10.7461 7.26086 15.0159 7.26086C19.2857 7.26086 22.7471 10.7223 22.7471 14.9921ZM21.1274 22.5653C19.4569 23.915 17.3308 24.7233 15.0159 24.7233C9.64149 24.7233 5.28467 20.3665 5.28467 14.9921C5.28467 9.61769 9.64149 5.26086 15.0159 5.26086C20.3903 5.26086 24.7471 9.61769 24.7471 14.9921C24.7471 17.3312 23.9218 19.4776 22.5465 21.1559L27.4225 26.032L26.0083 27.4462L21.1274 22.5653Z"
        />
    </svg>
</template>
